import { Col } from "reactstrap";
import LoginForm from "../Common/LoginForm";

const LoginSimpleContainer = () => {
  return (
    <Col sm="12" className="p-0">
      <div className="login-card login-dark">
        <LoginForm required />
      </div>
    </Col>
  );
};

export default LoginSimpleContainer;
